interface Props {
  color?: string
  width?: number
  height?: number
}

export const OpacityIcon = ({ color = '#6F6F6F', width = 21, height = 21 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.2002 21H0V16.7998H4.2002V21ZM12.5996 21H8.40039V16.7998H12.5996V21ZM21 21H16.7998V16.7998H21V21ZM8.40039 16.7998H4.2002V12.5996H8.40039V16.7998ZM16.7998 12.5996V16.7998H12.5996V12.5996H16.7998ZM4.2002 12.5996H0V8.40039H4.2002V12.5996ZM12.5996 12.5996H8.40039V8.40039H12.5996V12.5996ZM21 12.5996H16.7998V8.40039H21V12.5996ZM8.40039 8.40039H4.2002V4.2002H8.40039V8.40039ZM16.7998 8.40039H12.5996V4.2002H16.7998V8.40039ZM4.2002 4.2002H0V0H4.2002V4.2002ZM12.5996 4.2002H8.40039V0H12.5996V4.2002ZM21 4.2002H16.7998V0H21V4.2002Z"
        fill={color}
      />
    </svg>
  )
}
